import * as React from "react";
const SvgArrowRightUpLine = props => <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" {...props}><path d="m16.004 9.414-8.607 8.607-1.414-1.414L14.59 8H7.003V6h11v11h-2z" /></svg>;
export default SvgArrowRightUpLine;